// REACT IMPORTS
import React, { useEffect, useState } from "react";

// COMPONENT IMPORTS

// ICON IMPORTS
import PaymentMethodsComponent from "components/paymentMethod/PaymentMethodsComponent";
import expiryDateValidation, {
  cardToShortname,
  checkBankManualFormOrPlaid,
  checkNewPaymentDetails,
  checkOldPaymentDetails,
  formatExpirationDate,
  getBankName,
  getCardType,
  getMethod,
  getMethodCode,
  validateCard,
} from "utils/HelperFunctions";
import { valuesProps } from "types/paymentMethods";
import PaymentProcessStep2 from "pages/payments/PaymentProcessStep2";
import {
  oldPaymentMethodsGet,
  useBankData,
  useCardData,
  useHasLoadedPaymentMethods,
} from "store/slices/paymentMethodSlice";
import { AddCircleIconBlue, EyeIconBlue } from "utils/icon";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { addNotification, useUserData } from "store/slices/authSlice";
import {
  useLeadData,
  usePortalSettingsData,
} from "store/slices/dashboardSlice";
import {
  onSetFinalDisclosureLoading,
  onSetShowDisclosure,
  useIsLogin,
  useShowFinalDisclosure,
} from "store/slices/commonSlice";
import {
  convFeeGet,
  getpaymentPermission,
  markIncompletePayment,
  resetCheckDuplicatePayment,
  resetDuplicateOrder,
  setIsPaymentProcessing,
  verifyPaymentsViaStax,
  verifyWalletPay,
} from "store/slices/paymentsSlice";
import { useParams } from "react-router-dom";
import { decode } from "utils/HelperFunctions";
import WalletIcon from "icons/payments/WalletIcon";
import { initialValues } from "utils/countryAddressList";
import { PaymentGateway, PaymentMethodList } from "types/payments";
import { RootState } from "store/store";
import moment from "moment";
import {
  VerifyStaxCardPaymentParams,
  VerifyStripeCardPaymentParams,
} from "types/agreement";
import { useDefaultPaymentMethodView } from "hooks/useDefaultPaymentMethodView";
import { getScheduledPaymentFailureTotal } from "utils/paymentFee";

/* ------------------------------------- MAKE PAYMENT PAGE ------------------------------------- */
interface SchedulePaymentCompProps {
  handlePrev: any;
  isPaymentLink?: boolean;
  dataPayment: any;
  currentStep: number;
  setCurrentStep: (val: number) => void;
  setDataPayment: any;
  schedulePayment: boolean;
  isDataLoading: boolean;
  walletList: any;
  setSavedCardsEmail: any;
  handleGooglePay?: any;
  createPayPalIntent?: any;
  isGoogleLoading?: boolean;
  setIsAddNewCard?: any;
  isAddNewCard?: any;
  dataArr: any;
  isEdit?: boolean;
  paymentMethodList: PaymentMethodList[];
  setIsConfirmButtonDisable: any;
  handleApplePay: any;
  setAmtErr?: any;
  setIsEdit?: any;
  amtErr?: string | null;
  setShowPreview: any;
  setHideButtons: (val: boolean) => void;
  setFailedReason: (val: string) => void;
  setPaymentProcess: (val: string) => void;
  setAmount: (val: string | number) => void;
  sendEmail: (val: any) => void;
  setScheduleDate: (val: string | null) => void;
  setInvoiceId: (val: string | number) => void;
  cashAppRef: any;
  bankRef: any;
  cardRef: any;
  amazonRef: any;
  selectedMethod: string;
  setSelectedMethod: (val: string) => void;
  handlePlaidBankPayment: (
    val: any,
    isCCTokenAvailable: boolean
  ) => Promise<void>;
  isManualForm?: boolean;
  setIsManualForm?: any;
  setScheduleMethod?: (val: string) => void;
  activeOffer?: string;
  vdcId?: number;
}
const SchedulePaymentComp = (props: SchedulePaymentCompProps) => {
  const {
    handlePrev,
    isPaymentLink = false,
    dataPayment,
    setDataPayment,
    setCurrentStep,
    isDataLoading,
    walletList,
    setSavedCardsEmail,
    isAddNewCard,
    currentStep,
    dataArr,
    isEdit = false,
    handleGooglePay = null,
    createPayPalIntent,
    isGoogleLoading,
    paymentMethodList,
    setIsAddNewCard,
    setIsConfirmButtonDisable,
    handleApplePay = () => {},
    setAmtErr = () => {},
    setIsEdit = () => {},
    amtErr = null,
    setShowPreview,
    setHideButtons = () => {},
    setFailedReason = () => {},
    setPaymentProcess = () => {},
    setAmount = () => {},
    sendEmail = () => {},
    setScheduleDate = () => {},
    setInvoiceId = () => {},
    cashAppRef,
    bankRef,
    cardRef,
    amazonRef,
    selectedMethod,
    setSelectedMethod,
    handlePlaidBankPayment = async (
      val: any,
      isCCTokenAvailable: boolean
    ): Promise<void> => {
      return Promise.resolve();
    },
    isManualForm = true,
    setIsManualForm = () => {},
    setScheduleMethod = () => {},
    activeOffer = "",
    vdcId,
  } = props;
  const offerCallbackQuery =
    activeOffer && vdcId
      ? `&offer_type=${encodeURIComponent(activeOffer)}&vdc_id=${vdcId}`
      : "&offer_type=none";
  const offerPayload =
    activeOffer && vdcId
      ? { offer_type: activeOffer, vdc_id: vdcId }
      : {};

  const portalSettings = usePortalSettingsData();
  const cardList = useCardData();
  const bankList = useBankData();
  const hasLoadedPaymentMethods = useHasLoadedPaymentMethods();
  const userData = useUserData();
  const accountLeadData = useLeadData();
  const isLogin = useIsLogin();
  const dispatch = useAppDispatch();
  const { clusterId: cluster_id } = useParams();
  const clusterId = decode(cluster_id || "", true);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars

  const [values, setValues] = useState<valuesProps>(initialValues);
  const [email, setEmail] = useState<string>("");
  const [cardNumber, setcardNumber] = useState<string>("");
  const [iconType, setIconType] = useState<string>("");
  const [selectedState, setSelectedState] = useState<any>(undefined);
  const [isDateErr, setIsDateErr] = useState<boolean>(false);
  const [bankName, setBankName] = useState<any>("");
  const [bank, setBank] = useState<any>("");
  const [errMsg, setErrMsg] = useState<string | undefined>(undefined);
  const [isRingLoading, setIsRingLoading] = useState<boolean>(false);
  const [numberNotmatchedError, setnumberNotmatchedError] =
    useState<boolean>(false);
  const [isErr, setIsErr] = useState(-1);
  const [cardErrMsg, setCardErrMsg] = useState("");
  const { paymentPermission, conFee } = useAppSelector(
    (state: RootState) => state.payment
  );
  const showFinalDisclosure = useShowFinalDisclosure();

  const getAmount = () => {
    if (currentStep === 2) {
      if (
        dataArr?.transaction_type === "percent" &&
        dataArr?.percentage_amounts?.length > 0
      ) {
        return parseFloat(dataArr?.percentage_amounts[0])?.toFixed(2) || 0;
      } else {
        return dataArr?.transactions[0]?.amount;
      }
    } else {
      return 100;
    }
  };

  useEffect(() => {
    if (isAddNewCard) {
      let response = checkOldPaymentDetails({ dataPayment });
      setIsConfirmButtonDisable(response);
    } else {
      let response = checkNewPaymentDetails({
        values: values,
        cc_billing_address: portalSettings?.cc_billing_address,
        cc_billing_addr_mandatory: portalSettings?.cc_billing_addr_mandatory,
        selectedMethod,
        email,
        isErr,
        errMsg,
      });
      setIsConfirmButtonDisable(response || numberNotmatchedError);
    }
  }, [
    selectedMethod,
    values,
    email,
    isAddNewCard,
    dataPayment,
    isErr,
    errMsg,
    numberNotmatchedError,
  ]);

  const findBankByRoutingNumber = async (routingNumber: string) => {
    setIsRingLoading(true);
    try {
      let bankObj = await getBankName(routingNumber);
      if (bankObj?.type === "success") {
        setBankName(bankObj?.bank_name);
        setBank(bankObj?.bank_name);
      } else {
        setErrMsg("Invalid routing number");
        setIsRingLoading(false);
      }
    } catch (error) {
      console.log("error =====", error);
      setErrMsg("Invalid routing number");
      setIsRingLoading(false);
    } finally {
      setIsRingLoading(false);
    }
  };

  const handleChangeCard = (e: any, name: string) => {
    dispatch(setIsPaymentProcessing(true));
    if (name === "x_card_num") {
      let icon = getCardType(e.target.value) || iconType;
      if (icon === "amex") {
        if (e.target.value.length < 18) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(\d{6})(\d{5})/, "$1 $2 $3");
          setcardNumber(formattedCardNumber);
          setValues((state) => ({ ...state, [name]: e.target.value }));
        }
      } else {
        if (e.target.value.length < 20) {
          const cardNumber = e.target.value.replace(/\s/g, "");
          const formattedCardNumber = cardNumber
            .replace(/\D/g, "")
            .replace(/(\d{4})(?=\d)/g, "$1 ");
          setcardNumber(formattedCardNumber);
          setValues((state) => ({ ...state, [name]: e.target.value }));
        }
      }
    } else if (name === "x_card_code") {
      if (iconType === "amex") {
        if (e.target.value.length < 5) {
          setValues((state) => ({ ...state, [name]: e.target.value }));
        }
      } else {
        if (e.target.value.length < 4) {
          setValues((state) => ({ ...state, [name]: e.target.value }));
        }
      }
    } else if (name === "x_exp_date") {
      const inputValue = e.target.value;
      setIsDateErr(false);
      if (inputValue?.length < 6) {
        const isValidDate: any = expiryDateValidation(inputValue);
        const formattedDate = formatExpirationDate(inputValue);
        setValues({ ...values, [name]: formattedDate });
        !isValidDate?.isValid && inputValue?.length === 5 && setIsDateErr(true);
      }
    } else if (name === "x_country") {
      setValues((state) => ({ ...state, [name]: e?.value }));
    } else if (name === "x_state") {
      setValues((state) => ({ ...state, [name]: e?.name }));
    } else {
      setValues((state) => ({ ...state, [name]: e.target.value }));
    }
  };

  useEffect(() => {
    setDataPayment({
      ...dataPayment,
      paymentValues: { ...values, iconType },
    });
  }, [values]);

  const handleChangeBank = (e: any, name: string) => {
    dispatch(setIsPaymentProcessing(true));
    if (name === "routing_number") {
      if (e.target.value.length < 10) {
        setValues((state) => ({ ...state, [name]: e.target.value }));
        setBankName("");
        setBank("");
        setErrMsg(undefined);
        if (e.target.value.length === 9) {
          findBankByRoutingNumber(e.target.value);
        }
      }
    } else if (name === "r_account_number") {
      setnumberNotmatchedError(false);
      setValues((state) => ({ ...state, [name]: e.target.value }));
      if (values?.account_number?.length === e.target.value?.length) {
        setnumberNotmatchedError(values?.account_number !== e.target.value);
      }
    } else {
      setValues((state) => ({ ...state, [name]: e.target.value }));
    }
  };

  useEffect(() => {
    setValues((state: any) => ({
      ...state,
      x_payment_method: getMethodCode(selectedMethod),
    }));
    setDataPayment({
      ...dataPayment,
      x_payment_method: getMethodCode(selectedMethod),
    });
  }, [selectedMethod]);

  useEffect(() => {
    if (!cardNumber) {
      setIconType("");
      setValues((state) => ({ ...state, card_type: "" }));
      return;
    } else {
      setIconType(getCardType(cardNumber));
      setValues((state) => ({ ...state, card_type: getCardType(cardNumber) }));
    }
  }, [cardNumber]);

  const getPaymentMethodPermission = async () => {
    try {
      let payload = {
        accountid: userData?.data?.accountData?.accountid,
        clusterid: clusterId,
        lead_id: accountLeadData?.lead_id,
      };
      await dispatch(getpaymentPermission(payload));
    } catch (error) {
      console.log("getPaymentMethodPermission error =====", error);
    }
  };

  const onOldCardDataGet = async () => {
    try {
      let payload = {
        accountid: userData?.data?.accountData?.accountid,
        accounts_id: userData?.data?.accountData?.id,
        cluster_id: clusterId,
      };
      await dispatch(oldPaymentMethodsGet(payload)).unwrap();
    } catch (error: any) {
      console.log("old card data get erro:-->", error?.message);
    }
  };

  useEffect(() => {
    if (isLogin) {
      onOldCardDataGet();
      getPaymentMethodPermission();
    }
  }, []);

  const { hasUsableSavedMethods } = useDefaultPaymentMethodView({
    cardList,
    bankList,
    walletList,
    paymentMethodList,
    paymentPermission,
    isLogin,
    hasLoadedPaymentMethods,
    setShowSavedMethods: setIsAddNewCard,
    setDataPayment,
    selectedMethod,
    setSelectedMethod,
  });

  useEffect(() => {
    if (isAddNewCard && !showFinalDisclosure) {
      setHideButtons(false);
    } else {
      if (!showFinalDisclosure) {
        if (selectedMethod === "Card") {
          if (
            paymentPermission?.cc_gateway_name?.name ===
              PaymentGateway.STRIPE ||
            paymentPermission?.cc_gateway_name?.name === PaymentGateway.STAX
          ) {
            setHideButtons(true);
          } else {
            setHideButtons(false);
          }
        } else if (selectedMethod === "Bank") {
          if (
            paymentPermission?.ach_gateway_name?.name ===
              PaymentGateway.STRIPE ||
            paymentPermission?.ach_gateway_name?.name === PaymentGateway.STAX
          ) {
            setHideButtons(true);
          } else {
            let check = checkBankManualFormOrPlaid({
              manual_ach: portalSettings?.manual_ach,
              validate_bank_account: portalSettings?.validate_bank_account,
              isManualForm,
            });
            if (check) {
              setHideButtons(true);
            } else {
              setHideButtons(false);
            }
          }
        } else if (selectedMethod === "PayPal") {
          setHideButtons(true);
        } else if (selectedMethod === "Wire") {
          setHideButtons(false);
        } else if (selectedMethod === "Cash App Pay") {
          setHideButtons(true);
        } else if (selectedMethod === "Amazon Pay") {
          setHideButtons(true);
        } else if (selectedMethod === "Google Pay") {
          setHideButtons(true);
        } else if (selectedMethod === "Apple Pay") {
          setHideButtons(true);
        } else {
          setHideButtons(false);
        }
      }
    }
  }, [
    selectedMethod,
    isAddNewCard,
    portalSettings,
    isManualForm,
    showFinalDisclosure,
  ]);

  const markIncompleteOrder = async (orderId: number, error: any) => {
    const failureReason =
      typeof error?.message === "string" && error.message.trim()
        ? error.message
        : "Payment failed";
    const plannedDate =
      dataArr?.transactions?.[0]?.date ||
      dataArr?.transactions?.[0]?.payment_date ||
      dataArr?.transactions?.[0]?.billing_date ||
      dataArr?.start_date ||
      null;

    setAmount(getScheduledPaymentFailureTotal(getAmount(), conFee));
    setScheduleDate(plannedDate);
    setFailedReason(failureReason);

    try {
      if (orderId) {
        let res: any = await dispatch(
          markIncompletePayment({
            orderId,
            cluster_id:
              clusterId || userData?.data?.accountData?.clusterid,
            failed_reason: failureReason,
          })
        ).unwrap();
        if (res?.body?.success) {
          setAmount(
            getScheduledPaymentFailureTotal(
              getAmount(),
              conFee,
              res?.body?.data?.amount,
              res?.body?.data?.cc_fee
            )
          );

          let pay = {
            invoice_id: orderId,
            isRealTime: true,
            emails: [res?.body?.data?.email],
            isFuture: true,
          };
          await sendEmail(pay);
        }
      }
    } catch (markIncompleteError) {
      console.log("markIncompleteOrder error ======", markIncompleteError);
    } finally {
      setHideButtons(true);
      setPaymentProcess("false");
      dispatch(resetDuplicateOrder());
      dispatch(resetCheckDuplicatePayment());
      dispatch(onSetShowDisclosure(false));
      dispatch(onSetFinalDisclosureLoading(false));
      dispatch(setIsPaymentProcessing(false));
    }
  };

  const verifyStripeCardPayment = async ({
    intent,
    error,
    email,
    orderId,
    principalAmount,
  }: VerifyStripeCardPaymentParams) => {
    if (error) {
      await markIncompleteOrder(orderId || 0, error);
    } else {
      try {
        let payload = {
          lead_id: accountLeadData?.lead_id,
          cluster_id: userData?.data?.accountData?.clusterid,
          isrecurring: "Y",
          x_payment_method: "CC",
          phone_number: userData?.data?.accountData?.phone,
          description: "Online Payment",
          payment_note: "Custom Plan",
          amount:
            principalAmount ??
            (dataArr?.transaction_type === "amount"
              ? dataArr?.transactions.reduce(
                  (accumulator: any, currentValue: any) =>
                    accumulator + parseFloat(currentValue.amount),
                  0
                )
              : dataArr?.percentage_amounts.reduce(
                  (accumulator: any, currentValue: any) =>
                    accumulator + currentValue,
                  0
                )),
          transaction_id: intent,
          first_name: userData?.data?.accountData?.first_name || "",
          last_name: userData?.data?.accountData?.last_name || "",
          accountid: userData?.data?.accountData?.accountid || "",
          module: "process_payment",
          amountfield:
            dataArr?.transactions.map((item: any) => item.amount) || [],
          datefield:
            dataArr?.transactions.map((item: any) =>
              moment(
                item?.date || item?.payment_date || item?.billing_date
              ).format("MM/DD/YYYY")
            ) || [],
          percentagefield:
            dataArr?.transactions.map((item: any) => item.amount) || [],
          exclude_holidays: "N",
          email: userData?.data?.accountData?.email || "",
          schedule: dataArr?.schedule_fld,
          schedule_type: dataArr?.schedule_amount,
          total_payments: dataArr?.transactions.length,
          lead_owner: userData?.data?.accountData?.lead_owner,
          agent: userData?.data?.accountData?.lead_owner,
          start_date: dataArr?.start_date,
          amount_type:
            dataArr?.schedule_amount === "custom"
              ? dataArr?.transaction_type || "amount"
              : "amount",
          conv_fee: conFee,
          incomplete_order_id: orderId,
          custom_conv: "on",
          ...offerPayload,
        };
        let res: any = await dispatch(verifyWalletPay(payload)).unwrap();
        if (res?.body?.success) {
          const { schedule_id, invoice_id } = res?.body?.data;
          setPaymentProcess("true");
          setEmail(res?.body?.data?.email);
          setAmount(res?.body?.data?.total_amount);
          let isRealTime = true;
          if (
            res?.body?.data?.date &&
            !moment(res?.body?.data?.date).isSame(moment(), "days")
          ) {
            isRealTime = false;
            setScheduleDate(res?.body?.data?.date);
          }

          setInvoiceId(schedule_id);

          await dispatch(
            addNotification({
              initiated_by: "contact",
              event_type: "custom_plan",
              userid: userData?.data?.accountData?.leadData?.user_id,
              email: email,
              event_status: "created",
              activity_type: "payment_activity",
              clusterid: clusterId,
              communication_status: "",
              accounts_id: userData?.data?.accountData?.id,
              payment_amount:
                res?.body?.data?.totalTransactionAmount ||
                res?.body?.data?.amount,
              sch_id: schedule_id,
            })
          );

          if (isRealTime) {
            await dispatch(
              addNotification({
                initiated_by: "contact",
                event_type: "payment_processed",
                userid: userData?.data?.accountData?.leadData?.user_id,
                email: res?.body?.data?.email,
                event_status: "succeeded",
                activity_type: "payment_activity",
                clusterid: clusterId,
                communication_status: "",
                accounts_id: userData?.data?.accountData?.id,
                payment_amount: res?.body?.data?.amount,
                order_id: invoice_id,
              })
            );
          }
          let pay = {
            invoice_id,
            isRealTime,
            schedule_id,
            emails: [res?.body?.data?.email],
            isFuture: true,
          };
          await sendEmail(pay);
        } else {
          setFailedReason(res?.body?.data?.msg);
          setPaymentProcess("false");
          let paymentAmount = payload.amount || 0;
          await dispatch(
            addNotification({
              initiated_by: "contact",
              event_type: "payment_processed",
              userid: userData?.data?.accountData?.leadData?.user_id,
              email: "",
              event_status: "failed",
              activity_type: "payment_activity",
              clusterid: clusterId,
              communication_status: "",
              accounts_id: userData?.data?.accountData?.id,
              payment_amount: res?.body?.data?.amount,
              order_id: res?.body?.data?.invoice_id,
            })
          );
          setAmount(res?.body?.data?.total_amount || paymentAmount);
        }
        setHideButtons(true);
      } catch (error: any) {
        setFailedReason("Payment failed");
        setHideButtons(true);
        setPaymentProcess("false");
        console.log("handleApplePay error =====", error);
      } finally {
        await dispatch(resetDuplicateOrder());
        await dispatch(resetCheckDuplicatePayment());
        await dispatch(onSetShowDisclosure(false));
        await dispatch(onSetFinalDisclosureLoading(false));
      }
    }
  };

  const verifyStaxCardBank = async ({
    cc_token,
    cc_token2,
    x_method,
  }: VerifyStaxCardPaymentParams) => {
    try {
      let payload = {
        lead_id: accountLeadData?.lead_id,
        clusterid: userData?.data?.accountData?.clusterid,
        isrecurring: "Y",
        phone_number: userData?.data?.accountData?.phone,
        description: "Online Payment",
        payment_note: "Custom Plan",
        amount:
          dataArr?.transaction_type === "amount"
            ? dataArr?.transactions.reduce(
                (accumulator: any, currentValue: any) =>
                  accumulator + parseFloat(currentValue.amount),
                0
              )
            : dataArr?.percentage_amounts.reduce(
                (accumulator: any, currentValue: any) =>
                  accumulator + currentValue,
                0
              ),
        cc_token: cc_token,
        cc_token2: cc_token2,
        x_method: x_method,
        first_name: userData?.data?.accountData?.first_name || "",
        last_name: userData?.data?.accountData?.last_name || "",
        accountid: userData?.data?.accountData?.accountid || "",
        module: "process_payment",
        amountfield:
          dataArr?.transactions.map((item: any) => item.amount) || [],
        datefield:
          dataArr?.transactions.map((item: any) =>
            moment(
              item?.date || item?.payment_date || item?.billing_date
            ).format("MM/DD/YYYY")
          ) || [],
        percentagefield:
          dataArr?.transactions.map((item: any) => item.amount) || [],
        exclude_holidays: "N",
        email: userData?.data?.accountData?.email || "",
        schedule: dataArr?.schedule_fld,
        schedule_type: dataArr?.schedule_amount,
        total_payments: dataArr?.transactions.length,
        lead_owner: userData?.data?.accountData?.lead_owner,
        agent: userData?.data?.accountData?.lead_owner,
        start_date: dataArr?.start_date,
        amount_type:
          dataArr?.schedule_amount === "custom"
            ? dataArr?.transaction_type || "amount"
            : "amount",
        conv_fee: conFee,
        custom_conv: "off",
        ...offerPayload,
      };

      let res: any = await dispatch(verifyPaymentsViaStax(payload)).unwrap();

      if (res?.body?.success) {
        const { schedule_id, invoice_id } = res?.body?.data;
        setPaymentProcess("true");
        setEmail(res?.body?.data?.email);
        setAmount(
          res?.body?.data?.total_amount ||
            res?.body?.data?.amount ||
            payload?.amount
        );
        let isRealTime = true;
        if (
          res?.body?.data?.date &&
          !moment(res?.body?.data?.date).isSame(moment(), "days")
        ) {
          isRealTime = false;
          setScheduleDate(res?.body?.data?.date);
        }

        setInvoiceId(schedule_id);

        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "custom_plan",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: email,
            event_status: "created",
            activity_type: "payment_activity",
            clusterid: clusterId,
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount:
              res?.body?.data?.totalTransactionAmount ||
              res?.body?.data?.total_amount ||
              res?.body?.data?.amount ||
              payload?.amount,
            sch_id: schedule_id,
          })
        );

        if (isRealTime) {
          await dispatch(
            addNotification({
              initiated_by: "contact",
              event_type: "payment_processed",
              userid: userData?.data?.accountData?.leadData?.user_id,
              email: res?.body?.data?.email,
              event_status: "succeeded",
              activity_type: "payment_activity",
              clusterid: clusterId,
              communication_status: "",
              accounts_id: userData?.data?.accountData?.id,
              payment_amount: res?.body?.data?.amount,
              order_id: invoice_id,
            })
          );
        }

        let pay = {
          invoice_id,
          isRealTime,
          schedule_id,
          emails: [res?.body?.data?.email],
          isFuture: true,
        };
        await sendEmail(pay);
      } else {
        if (res?.body?.data?.invoice_id) {
          const { invoice_id } = res?.body?.data;

          let pay = {
            invoice_id,
            emails: [res?.body?.data?.email || email],
            isRealTime: true,
          };
          await sendEmail(pay);
          setInvoiceId(invoice_id);
        }

        setFailedReason(res?.body?.data?.msg);
        setPaymentProcess("false");
        await dispatch(
          addNotification({
            initiated_by: "contact",
            event_type: "payment_processed",
            userid: userData?.data?.accountData?.leadData?.user_id,
            email: "",
            event_status: "failed",
            activity_type: "payment_activity",
            clusterid: clusterId,
            communication_status: "",
            accounts_id: userData?.data?.accountData?.id,
            payment_amount:
              res?.body?.data?.total_amount ||
              res?.body?.data?.amount ||
              payload?.amount,
            order_id: res?.body?.data?.invoice_id,
          })
        );
        setAmount(
          res?.body?.data?.total_amount ||
            res?.body?.data?.amount ||
            payload?.amount
        );
      }
      setHideButtons(true);
    } catch (error: any) {
      setFailedReason("Payment failed");
      setHideButtons(true);
      setPaymentProcess("false");
      console.log("handleApplePay error =====", error);
    } finally {
      await dispatch(resetDuplicateOrder());
      await dispatch(resetCheckDuplicatePayment());
      await dispatch(onSetShowDisclosure(false));
      await dispatch(onSetFinalDisclosureLoading(false));
    }
  };

  return (
    <>
      <div className="lg:hidden flex justify-between items-center lg:px-0 px-5 md2:flex-nowrap flex-wrap gap-1">
        <p
          className={`${
            currentStep === 2 ? "text-btnPrimaryActive" : "text-txtPrimary"
          } font-medium text-base w-full`}
        >
          Payment method
        </p>
        <div className="w-full flex items-center md2:justify-end gap-1 justify-between">
          <div className="flex items-center gap-5">
            <p
              className="flex gap-2 items-center text-sm hover:!text-btnPrimaryHover text-btnPrimaryActive cursor-pointer"
              onClick={() => {
                setScheduleMethod(
                  getMethod(isAddNewCard, dataPayment, selectedMethod) ?? "CC"
                );
                setShowPreview(true);
              }}
            >
              <EyeIconBlue /> Preview
            </p>
          </div>
          {isAddNewCard ? (
            <p
              onClick={() => setIsAddNewCard(false)}
              className="flex gap-2 items-center cursor-pointer xl:text-sm text-xs font-medium text-blue hover:!text-btnPrimaryHover"
            >
              <AddCircleIconBlue /> Add New
            </p>
          ) : (
            hasUsableSavedMethods && (
              <p
                className=" xl:text-sm text-xs text-blue cursor-pointer flex gap-2 hover:!text-btnPrimaryHover items-center"
                onClick={() => setIsAddNewCard(true)}
              >
                <span>
                  <WalletIcon
                    className="group"
                    _className="group-hover:!fill-btnPrimaryHover"
                  />
                </span>
                Select saved method
              </p>
            )
          )}
        </div>
      </div>
      <div className="lg:pt-[40px] lg:pb-9 lg:h-full lg:px-0 px-5">
        <div
          className={`lg:max-w-[510px] flex flex-col lg:gap-10 gap-5 text-LightTextParagraph lg:w-[98%] lg:h-full`}
        >
          {isAddNewCard ? (
            <>
              <div>
                {isPaymentLink && (
                  <div className="flex justify-between items-center mb-5">
                    <p className="lg:text-xl text-lg font-medium">
                      Payment method
                    </p>

                    <p
                      onClick={() => {
                        dispatch(setIsPaymentProcessing(true));
                        setIsAddNewCard(false);
                      }}
                      className="flex gap-2 items-center cursor-pointer xl:text-sm text-xs  font-medium text-blue hover:!text-btnPrimaryHover"
                    >
                      <AddCircleIconBlue /> Add New
                    </p>
                  </div>
                )}

                <PaymentProcessStep2
                  data={dataPayment}
                  setData={setDataPayment}
                  setCurrentStep={setCurrentStep}
                  isDataLoading={isDataLoading}
                  currentStep={currentStep}
                  walletList={walletList}
                  setSavedCardsEmail={setSavedCardsEmail}
                  isPaymentLink={isPaymentLink}
                  setShowPreview={(val: boolean) => {
                    setScheduleMethod(
                      getMethod(isAddNewCard, dataPayment, selectedMethod) ??
                        "CC"
                    );
                    setShowPreview(val);
                  }}
                  paymentMethodList={paymentMethodList}
                  setSelectedMethod={setSelectedMethod}
                />
              </div>
            </>
          ) : (
            <>
              <PaymentMethodsComponent
                cardData={{
                  cardNumber,
                  isDateErr,
                  isErr,
                  cardErrMsg,
                  handleChangeCard,
                  validateCard: () =>
                    validateCard({
                      values,
                      iconType,
                      setIsErr,
                      setCardErrMsg,
                      setErrMsg,
                    }),
                  iconType,
                  setIsAddNewCardMakePayment: setIsAddNewCard,
                  isAddNewCardMakePayment: isAddNewCard,
                  setIconType,
                  showNewStripeCardForm: true,
                }}
                bankData={{
                  bankName,
                  numberNotmatchedError,
                  setnumberNotmatchedError,
                  handleChangeBank,
                  selectedState,
                  setSelectedState,
                  stripeBankURL: `${window.location.href}?pay=schedule&method=bank&amount=${getAmount()}&isRecurring=true${offerCallbackQuery}`,
                  isManualForm,
                  setIsManualForm,
                  handlePlaidBankPayment,
                  checkNegativeBalance: true,
                }}
                paymentConfig={{
                  paymentMethodList,
                  selectedMethod,
                  setSelectedMethod,
                  amount: getAmount(),
                  isPaymentLink,
                  isRecurring: true,
                  isEdit,
                  setIsEdit,
                  isSchedulePayment: true,
                  dataArr,
                  useStripeGooglePay: true,
                  useStripeApplePay: true,
                }}
                paymentHandlers={{
                  handleGooglePay: (tokenData: any, amount: any) => {
                    console.info(
                      "[Stripe Google Pay][schedule-method] wallet confirmed",
                      {
                        hasIntent: Boolean(tokenData?.id),
                        paymentMethod: "GP",
                      }
                    );
                    handleGooglePay(tokenData, amount);
                  },
                  createPayPalIntent,
                  handleApplePay,
                  handleBack: handlePrev,
                  setShowPreview: (val: boolean) => {
                    setScheduleMethod(
                      getMethod(isAddNewCard, dataPayment, selectedMethod) ??
                        "CC"
                    );
                    setShowPreview(val);
                  },
                  verifyStaxCardBank,
                  verifyStripeCardPayment,
                }}
                paymentUrls={{
                  cashAppURL: `${window.location.href}?pay=schedule&method=cashapp&amount=${getAmount()}&isRecurring=true${offerCallbackQuery}`,
                  stripeAmazonPayURL: `${window.location.href}?pay=schedule&method=amazonPay&amount=${getAmount()}&isRecurring=true${offerCallbackQuery}`,
                }}
                formState={{
                  values,
                  email,
                  setEmail,
                  errMsg,
                  amtErr: undefined,
                  setAmtErr,
                  isRingLoading,
                }}
                paymentGatewayState={{
                  isGoogleLoading,
                  disableInputFields: false,
                  hasGooglePay: true,
                }}
                componentRefs={{
                  cashAppRef,
                  bankRef,
                  cardRef,
                  amazonRef,
                }}
                description={"Custom Plan"}
                phoneAndAddressConfig={{}}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SchedulePaymentComp;
